import styled from '@emotion/styled';
import { colorConstants } from 'config/colorConstants';

/** Class hooks for the antd Input — antd's Less overrides beat plain inline styles on :focus/.ant-input-focused, so border/shadow state has to be applied via a stylesheet class instead. */
export const INLINE_EDITABLE_NAME_INPUT_CLASS = 'inline-editable-name-input';
export const INLINE_EDITABLE_NAME_INPUT_ERROR_MODIFIER = 'inline-editable-name-input--error';

export const StyledInlineEditableNameEditor = styled.div`
    position: relative;
    display: inline-block;
    width: min(520px, 100%);
    max-width: 100%;
    vertical-align: top;

    .${INLINE_EDITABLE_NAME_INPUT_CLASS},
    .${INLINE_EDITABLE_NAME_INPUT_CLASS}:focus,
    .${INLINE_EDITABLE_NAME_INPUT_CLASS}.ant-input-focused {
        border-radius: 6px !important;
        border: 1px solid ${colorConstants.violet} !important;
        background: ${colorConstants.white} !important;
        box-shadow: 0 0 0 2px ${colorConstants.controlOutline} !important;
        outline: none !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 22px !important;
        color: ${colorConstants.greyAlt20} !important;
    }

    .${INLINE_EDITABLE_NAME_INPUT_CLASS}.${INLINE_EDITABLE_NAME_INPUT_ERROR_MODIFIER},
    .${INLINE_EDITABLE_NAME_INPUT_CLASS}.${INLINE_EDITABLE_NAME_INPUT_ERROR_MODIFIER}:focus,
    .${INLINE_EDITABLE_NAME_INPUT_CLASS}.${INLINE_EDITABLE_NAME_INPUT_ERROR_MODIFIER}.ant-input-focused {
        border-color: ${colorConstants.redAlt} !important;
        box-shadow: none !important;
    }
`;

export const StyledInlineEditableNameLabel = styled.span`
    color: ${colorConstants.greyAlt20};
`;

export const StyledInlineEditableNameActions = styled.div`
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    z-index: 31;
`;

export const StyledInlineEditableNameActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    padding: 0;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid ${colorConstants.toolbarBorderGrey};
    background: ${colorConstants.white};
    color: ${colorConstants.blackTransparent88};
    cursor: pointer;

    svg {
        display: block;
        flex-shrink: 0;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const StyledInlineEditableNameError = styled.p`
    margin: 38px 0 0;
    font-size: 12px;
    line-height: 16px;
    color: ${colorConstants.redAlt};
`;
